/* eslint-disable no-console */
import { format, parseISO } from 'date-fns';

export const formatDate = (date: string) => {
  if (!date) return '';

  try {
    const dateObject = parseISO(date);
    const formattedDate = format(dateObject, 'yyyy-MM-dd');
    return formattedDate;
  } catch (error) {
    console.error('Invalid date format:', date, error);
    return '';
  }
};

export const formatMonthYear = (date: string) => {
  if (!date) return '';

  try {
    const dateObject = parseISO(date);
    const formattedDate = format(dateObject, 'MMMM yyyy');
    return formattedDate;
  } catch (error) {
    console.error('Invalid date format:', date, error);
    return '';
  }
};

export const formatFullDate = (date: string) => {
  if (!date) return '';

  try {
    const dateObject = parseISO(date);
    const formattedDate = format(dateObject, 'd, MMM yyyy');
    return formattedDate;
  } catch (error) {
    console.error('Invalid date format:', date, error);
    return '';
  }
};

export const formattedTime = (date: string) => {
  if (!date) return '';

  try {
    const dateObject = parseISO(date);
    const formattedDate = format(dateObject, 'h:mm a');
    return formattedDate;
  } catch (error) {
    console.error('Invalid date format:', date, error);
    return '';
  }
};

export const toDateInputValue = (iso?: string | null) => {
  if (!iso) return '';
  const d = new Date(iso);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`; 
};